import React from 'react';

const Loader = () => (
  <div className="transform translate-x-1/2 translate-y-1/2 right-1/2 bottom-1/2 ">
    <div className="w-8 h-8 border-4 border-solid rounded-full border-t-transparent animate-spin border-primary"></div>
  </div>
);

export default Loader;
